import { combineReducers } from "redux";
import { api } from "./middleware/api"
import DeliveryAddressReducer from "./Reducers/DeliveryAddress"
import cartReducers from "./Reducers/cartSlice";
import rootReducer from "Redux/reducers";
import dishesSlice from "./Reducers/DishSlice";
import AddonsSlice from "./Reducers/AddonsSlice";

export default combineReducers({
  deliveryAddress: DeliveryAddressReducer,
  cart: cartReducers,
  [api.reducerPath]: api.reducer,
  reduxReducers: rootReducer,
  dishes: dishesSlice,
  addOns: AddonsSlice
});
